import { Box } from '@mui/material';
import ModalComponent from '../ModalComponent';
import ButtonComponent from '../ButtonComponent';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../context/AppContextProvider';
import { Cancel } from '@mui/icons-material';

interface ImageDialogComponentProps {
  isOpen: boolean;
  handleClose: () => void;
  imageUrl: string | null;
  title?: string;
  maxWidth?: string;
  maxHeight?: string;
}

const ImageModalComponent = ({
  isOpen,
  handleClose,
  imageUrl,
  title,
  maxWidth,
  maxHeight,
}: ImageDialogComponentProps) => {
  const { setIsShowLoadingComponent } = useContext(AppContext);

  const renderCloseButton = () => {
    return (
      <Box display={'flex'} justifyContent={'end'}>
        <ButtonComponent size={'small'} color={'error'} onClick={handleClose}>
          <Cancel />
        </ButtonComponent>
      </Box>
    );
  };

  useEffect(() => {
    if (isOpen) {
      setIsShowLoadingComponent(true);
    }
  }, [isOpen]);
  return (
    <ModalComponent
      isOpen={isOpen}
      title={title ? title : 'Visualização da Imagem'}
      additionalTopRightComponent={renderCloseButton()}
      onClose={handleClose}
      width={600}
    >
      <Box display="flex" justifyContent="center">
        <img
          width={'100%'}
          src={imageUrl ?? ''}
          alt="Evento"
          onLoad={() => setIsShowLoadingComponent(false)}
          style={{
            maxWidth: maxWidth ?? '100%',
            maxHeight: maxHeight ?? '400px',
          }}
        />
      </Box>
    </ModalComponent>
  );
};

export default ImageModalComponent;
